import { Link } from "@tanstack/react-router";

import { useAppConfig } from "../lib/appConfig";

/**
 * Slim banner that surfaces server-side bootstrap mode. Renders only when
 * the server flips `discrete_only_mode` on — otherwise the component
 * returns null and adds zero layout weight.
 *
 * Lives above the normal SiteHeader content and above the monastic
 * /practice shell so it can't be missed.
 */
export function BootstrapBanner() {
  const { data } = useAppConfig();
  if (!data?.discrete_only_mode) return null;
  return (
    <div className="border-b border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-900/50 dark:bg-amber-950/40 dark:text-amber-200 text-xs">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 py-1.5 flex items-center gap-2 flex-wrap">
        <span className="uppercase tracking-wide font-medium text-[10px] text-amber-700 dark:text-amber-400">
          bootstrap mode
        </span>
        <span className="text-amber-900 dark:text-amber-200">
          Practice is restricted to discrete-choice questions while we
          recalibrate the engine. Free-text formats are temporarily hidden.
        </span>
        <Link
          to="/about"
          className="ml-auto text-amber-700 hover:text-amber-900 dark:text-amber-400 dark:hover:text-amber-200 underline underline-offset-2 decoration-1 shrink-0"
        >
          Why?
        </Link>
      </div>
    </div>
  );
}
